import React, { useState } from "react";
import dayjs from "dayjs";
import MUIDataTable from "../../../components/MUIGrid";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { IoEyeSharp } from "react-icons/io5";

const LogsModal = ({ logsData, getSessionLogInfo, isLoading }) => {
  dayjs.extend(utc);
  dayjs.extend(timezone);

  const [loadingRow, setLoadingRow] = useState(null);

  function convertToLocalFormatted(datetimeStr) {
    return dayjs.utc(datetimeStr).local().format("ddd, MMM D, YYYY h:mm A");
  }

  const columns = [
    { field: "counter", headerName: "Sr#", width: 80 },
    {
      field: "login_time",
      headerName: "Login Time",
      minWidth: 100,
      flex: 1,
      valueFormatter: (params) =>
        params.value ? convertToLocalFormatted(params.value) : "N/A",
    },
    {
      field: "logout_time",
      headerName: "Logout Time",
      minWidth: 100,
      flex: 1,
      valueFormatter: (params) =>
        params.value ? convertToLocalFormatted(params.value) : "N/A",
    },
    {
      field: "session_duration",
      headerName: "Session Duration",
      minWidth: 100,
      flex: 1,
      renderCell: (params) =>
        params.value ? (
          <span className=" py-1 px-2 !rounded hover:cursor-pointer ml-3">
            {formatTimeToHMS(params.value)}
          </span>
        ) : (
          <span className=" py-1 px-2 !rounded hover:cursor-pointer ml-3">
            N/A
          </span>
        ),
    },
    {
      field: "session_id",
      headerName: "Total Hit",
      minWidth: 100,
      align: "center",
      headerAlign: "center",
      flex: 1,
      renderCell: (params) => (
        <div className="cursor-pointer">
          {loadingRow === params.rowNode.id && isLoading ? (
            <img src="/img/loading.gif" className="w-5" alt="" />
          ) : params?.row?.session_id_log ? (
            <span className="text-center bg-[#93c5fd] py-1 px-1 !rounded hover:cursor-pointer ">
              {params.row.session_id_log.toString()}
            </span>
          ) : (
            <IoEyeSharp
              size={16}
              onClick={() => {
                setLoadingRow(params.rowNode.id);
                getSessionLogInfo(params.value, params.rowNode.id - 1);
              }}
            />
          )}
        </div>
      ),
    },
  ];

  function formatTimeToHMS(timeStr) {
    if (timeStr === "00:00:00" || timeStr === "00:00:00.000000") {
      return "N/A";
    }

    const hasMilliseconds = timeStr.includes(".");

    let parsedTime;

    if (hasMilliseconds) {
      // Regex to extract hours, minutes, seconds, and milliseconds
      const regex = /^(\d{2}):(\d{2}):(\d{2})\.(\d{6})$/;
      const match = timeStr.match(regex);

      if (match) {
        const hours = parseInt(match[1], 10);
        const minutes = parseInt(match[2], 10);
        const seconds = parseInt(match[3], 10);
        const milliseconds = parseInt(match[4], 10);

        // Create a duration using dayjs with hours, minutes, seconds, and milliseconds
        parsedTime = dayjs.duration({
          hours,
          minutes,
          seconds,
          milliseconds,
        });
      }
    } else {
      // Handle time in format "HH:mm:ss"
      const [hours, minutes, seconds] = timeStr.split(":").map(Number);
      parsedTime = dayjs.duration({
        hours,
        minutes,
        seconds,
      });
    }

    // Build the formatted string, omitting zero values
    const parts = [];

    // Include hours if greater than 0
    if (parsedTime?.hours() > 0) {
      parts.push(`${parsedTime.hours()} hours`);
    }

    // Include minutes if greater than 0
    if (parsedTime?.minutes() > 0) {
      parts.push(`${parsedTime.minutes()} minutes`);
    }

    // Include seconds if greater than 0
    if (parsedTime?.seconds() > 0) {
      parts.push(`${parsedTime.seconds()} seconds`);
    }

    if (parts.length === 0) {
      return "N/A";
    }

    return parts.join(", ");
  }

  return (
    <MUIDataTable
      columnDefs={columns}
      items={(logsData.length ? logsData : [])?.map((record, index) => {
        const {
          login_time,
          logout_time,
          session_duration,
          session_id,
          session_id_log,
        } = record;
        return {
          session_id_log: session_id_log,
          counter: index + 1,
          login_time,
          logout_time,
          session_duration,
          session_id: session_id,
        };
      })}
      totalItems={logsData?.length}
      height="60vh"
      pagination="No"
      searchable="No"
      showCount="No"
      sortingMode="client"
      paginationMode="client"
      toolbar="No"
      sx={{
        "& .MuiDataGrid-cell:focus": {
          outline: "none",
        },
        "& .MuiDataGrid-columnHeader:focus": {
          outline: "none",
        },
        "& .MuiDataGrid-columnHeader--sorted": {
          border: "none",
        },
      }}
    />
  );
};

export default LogsModal;
